<app-header></app-header>

<app-error *ngIf="isError" [message]="errorMessage"></app-error>
<div *ngIf="!isRequestCreatedSuccessfully">
  <div style="height: 100px; background: #EEEEEE 0% 0% no-repeat padding-box;" class="border-3 border-bottom">
    <div class="row">
      <div class="col-md-12">
        <h2 class="pt-4 font-color-navy text-center"><b>Request A Review</b></h2>
      </div>
    </div>
  </div>
  <form (ngSubmit)="onSubmit()" #requestForm="ngForm" ngForm="requestForm">
    <div class="form-group" id="request-group" ngModelGroup="requestData" #requestData="ngModelGroup">
      <div class="container d-flex justify-content-center text-center">
        <div>
          <div style="display:flex;">
            <div class="request-type-left text-center pt-3">
              <label>
                <input type="radio" class="radio-inline" name="requestType" value="Approval" ngModel required #requestType="ngModel" />
                <span class="font-color-navy h6">Approval</span>
              </label>
            </div>
            <div class="request-type-right text-center pt-3">
              <label>
                <input type="radio" class="radio-inline" name="requestType" value="Acceptance" ngModel required #requestType="ngModel" />
                <span class="font-color-navy h6">Acceptance</span>
              </label>
            </div>
          </div>
          <span class="help-block" style="color:red" *ngIf="!requestType.valid && requestType.touched">Please select a request type</span>
        </div>
      </div>
      <br />
      <div class="d-flex justify-content-center" *ngIf="requestType.value=='Acceptance'">
        <div class="form-group font-color-navy h6" id="JustificationSection">
          <label>Justification Type: </label>
          <label>
            <input type="radio" class="radio-inline" name="justificationType" value="BugId" ngModel [required]="requestType.value=='Acceptance'" />
            <span class="font-color-navy h6 m-lg-1">Bug Id</span>
          </label>
          <label>
            <input type="radio" class="radio-inline" name="justificationType" value="FreeText" ngModel [required]="requestType.value=='Acceptance'" />
            <span class="font-color-navy h6 m-lg-1">Free Text</span>
          </label>
        </div>
      </div>

      <br />
      <div class="container-fluid container-shadow font-color-navy px-5" id="containerCreate" *ngIf="requestType.valid && requestType.dirty">
        <div id="requestCreateGroup">
          <div class="panel-collapse">
            <div class="panel-heading">
              <div class="accordion-circle-heading bg-orange font-color-orange" data-bs-toggle="collapse" data-bs-target="#details">
                <div><i class="fa fa-file-text pt-1 pb-1 px-2"></i><span>Details</span></div>
              </div>
            </div>
            <br />
            <div class="vertical-line">
              <div class="panel-body mx-4" id="details">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <input type="text" class="form-control" name="title" style="width:100%" ngModel minlength="4" maxlength="255" required #title="ngModel" />
                      <small class="form-text text-muted">Enter the title of the request</small>
                    </div>
                    <span class="help-block" style="color:red" *ngIf="!title.valid && title.touched">Please enter a title</span>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <select class="form-control control-bg" name="project" ngModel #projectcontrol="ngModel" required>
                        <option *ngFor="let project of projects" [value]="project.projectName">{{project.projectName}}</option>
                      </select>
                      <small class="form-text text-muted">Select a project where the request will be stored</small>
                    </div>
                  </div>
                </div>
                <br />

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group" *ngIf="(projectcontrol.value.length > 0)">
                      <div class="input-group">
                        <div matAutocompleteOrigin #taskOrigin="matAutocompleteOrigin">
                          <mat-form-field class="form-group" appearance="outline">
                            <input type="text" placeholder="Select task(s)*" [formControl]="taskControl" matInput [matAutocomplete]="autoTasks"
                                   [matAutocompleteConnectedTo]="taskOrigin" class="form-control">
                            <mat-autocomplete [panelWidth]="'auto'" #autoTasks="matAutocomplete" (optionSelected)="onTaskSelected($event)">
                              <mat-option *ngFor="let option of tasksfilteredOptions | async" [value]="option.id">
                                {{option.title}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                          <span class="btn background-orange btn-sm">
                            <button id="openQueryDialogButton" type="button" class="btn btn-default" title="Select through a query" data-disabled-onsubmit="true" data-bs-toggle="modal" data-bs-target="#queryDialog">
                              <mat-icon mat-raised-button (click)="openQueryDialog()" style="color:#FFFFFF;">arrow_drop_down</mat-icon>
                            </button>
                          </span>
                          <span *ngIf="isTaskLoading">
                            <app-loading [displayeMessage]="false"></app-loading>
                          </span>
                          <span class="text-danger" *ngIf="isNoTaskFound">
                            <small style="padding-left:20px;">{{errorMessage}}</small>
                          </span>
                          <span class="text-danger" *ngIf="isDuplicateTask">
                            <small style="padding-left:20px;">{{errorMessage}}</small>
                          </span>
                        </div>

                      </div>
                      <span class="text-danger field-validation-error" data-valmsg-replace="true" data-valmsg-for="requirementSelector"></span>
                      <small class="form-text text-muted">Enter the ID or a part of the title of the tasks. Only Business and User Requirements are selectable</small>

                      <br />
                      <div class="row">
                        <div class="offset-md-11 col-md-1">
                          <button class="btn btn-default btn-xs" id="requirementRemove" type="button"><i class="fa fa-trash font-color-orange"></i></button>
                        </div>
                      </div>
                      <table class="table table-bordered table-striped" id="selectedTasks">
                        <thead class="table-secondary">
                          <tr>
                            <th class="font-color-navy">NUMBER</th>
                            <th class="font-color-navy">TYPE</th>
                            <th class="font-color-navy">TITLE</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let task of taskList; index as i" [attr.id]="task.id">
                            <td>{{task.id}}</td>
                            <td>{{task.shortType}}</td>
                            <td>{{task.title}}</td>
                            <td><button id="remove" (click)="removeTask(task)" class="btn-new-ui-xs">Remove</button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-collapse">
            <div class="panel-heading">
              <div class="accordion-circle-heading background-navy" data-target="#people" data-toggle="collapse" data-bs-toggle="collapse" data-bs-target="#people" aria-controls="people">
                <div class=""><i class="fa fa-users pt-1 pb-1 px-2"></i><span>People</span></div>
              </div>
            </div>
            <div class="vertical-line">
              <div class="panel-body mx-4" id="people">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label for="reviewerSelector">Reviewer(s):</label>
                      <div matAutocompleteOrigin #origin="matAutocompleteOrigin" class="col-md-6">
                        <mat-form-field class="form-group" appearance="outline">
                          <input type="text" placeholder="Select user*" [formControl]="reviewerControl" matInput [matAutocomplete]="auto" [matAutocompleteConnectedTo]="origin" class="form-control">
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelected($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.adsId">
                              {{option.displayName}} ({{option.login}})
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                        <span *ngIf="isReviewerLoading">
                          <app-loading [displayeMessage]="false"></app-loading>
                        </span>
                        <span class="text-danger" *ngIf="isNoReviewerFound">
                          <small>No such user found!</small>
                        </span>
                      </div>
                      <span *ngIf="isReviewerAlreadySelected" style="color:red">
                        The selected user is already moderator for this request.
                      </span>
                      <span *ngIf="isRequestor" style="color:red">
                        The requestor cannot be reviewer/moderator of this request.
                      </span>
                      <br />
                      <span class="text-danger field-validation-error" data-valmsg-replace="true" data-valmsg-for="reviewerSelector"></span>
                      <small class="form-text text-muted">Enter the name of the reviewer. A reviewer can also be an approver/acceptor based on the Request Type</small>
                      <div class="row">
                        <div class="offset-md-11 col-md-1">
                          <button class="btn btn-default btn-xs" id="reviewerRemove" type="button"><i class="fa fa-trash font-color-orange"></i></button>
                        </div>
                      </div>
                      <table class="table table-bordered table-striped" id="selectedReviewers">
                        <thead class="table-secondary">
                          <tr>
                            <th class="font-color-navy text-uppercase">Name</th>
                            <th class="font-color-navy text-uppercase">Related Scope</th>
                            <th class="font-color-navy text-uppercase">Approver/Acceptor?</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let reviewer of reviewers; index as i">
                            <td>{{reviewer.user.displayName}}</td>
                            <td><input type="text" [name]="'RelatedScope' + reviewer.user.adsId" class="form-control" value="reviewer" [(ngModel)]="reviewer.relatedScope" /></td>
                            <td><mat-slide-toggle color="blue" [name]="'isApprover' + reviewer.user.adsId" [(ngModel)]="reviewer.isApprover"></mat-slide-toggle></td>
                            <td><button id="remove" (click)="removeReviewer(reviewer)" class="btn-new-ui-xs">Remove</button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="moderatorSelector">Moderator(s):</label>
                      <div matAutocompleteOrigin #moderatorOrigin="matAutocompleteOrigin" class="col-md-10">
                        <mat-form-field class="form-group">
                          <input type="text" placeholder="Select user" [formControl]="moderatorControl" matInput [matAutocomplete]="autoModerator" [matAutocompleteConnectedTo]="moderatorOrigin" class="form-control">
                          <mat-autocomplete #autoModerator="matAutocomplete" (optionSelected)="onModeratorSelected($event)">
                            <mat-option *ngFor="let option of moderatorfilteredOptions | async" [value]="option.adsId">
                              {{option.displayName}} ({{option.login}})
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                        <span *ngIf="isModeratorLoading">
                          <app-loading [displayeMessage]="false"></app-loading>
                        </span>
                        <span class="text-danger" *ngIf="isNoModeratorFound">
                          <small>No such user found!</small>
                        </span>
                      </div>
                      <span *ngIf="isModeratorAlreadySelected" style="color:red">
                        The selected user is already reviewer for this request.
                      </span>
                      <span *ngIf="isRequestor" style="color:red">
                        The requestor cannot be reviewer/moderator of this request.
                      </span>
                      <br />
                      <small class="form-text text-muted">Enter the name of the moderator. A moderator can also perform same actions as requestor.</small>

                      <div class="row">
                        <div class="offset-md-10 col-md-1">
                          <div class="btn btn-default btn-xs" id="moderatorRemove"><i class="fa fa-trash font-color-orange"></i></div>
                        </div>
                      </div>
                      <table class="table table-bordered table-striped " id="selectedModerators">
                        <thead class="table-secondary font-color-navy">
                          <tr>
                            <th class="font-color-navy">Name</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let moderator of moderators; index as i">
                            <td>{{moderator.user.displayName}}</td>
                            <td><button id="remove" (click)="removeModerator(moderator)" class="btn-new-ui-xs">Remove</button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="panel-collapse">
            <div class="panel-heading">
              <div class="accordion-circle-heading background-navy" data-toggle="collapse" data-bs-toggle="collapse" data-target="#deadline" data-bs-target="#deadline">
                <div class=""><i class="fa fa-comment pt-1 pb-1 px-2"></i><span>Deadline</span></div>
              </div>

            </div>
            <br />
            <div class="panel-body mx-4" id="deadline">
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="picker" name="deadline" [min]="minDate" ngModel [required]="true" />
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <br />
            </div>
          </div>
          <br />
          <div class="panel-collapse">
            <div class="panel-heading">
              <div class="accordion-circle-heading background-navy" data-toggle="collapse" data-bs-toggle="collapse" data-target="#message" data-bs-target="#message">
                <div class=""><i class="fa fa-comment pt-1 pb-1 px-2"></i><span>Message</span></div>
              </div>

            </div>
            <br />
            <div class="panel-body mx-4" id="message">
              <div class="row">
                <div class="col-md-12">
                  <span>
                    <editor name="notificationMessage" style="border: none !important;" [init]="init" id="file-picker" class="form-control control-bg" ngModel></editor>
                    <small class="form-text text-muted">The message will be sent to the reviewer(s) within the notification of the assignment</small>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span *ngIf="isrequestCreating">
          <app-loading [displayeMessage]="false"></app-loading>
        </span>
        <div class="d-flexd-flex justify-content-end text-end" *ngIf="!submitted">
          <button [ngClass]="(requestForm.valid && taskList.length > 0 && reviewers.length > 0)? 'btn-new-ui':'btn-new-ui-disabled'"
                  type="submit"
                  [disabled]="!(requestForm.valid && taskList.length > 0 && reviewers.length > 0)">
            Submit
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div *ngIf="isRequestCreatedSuccessfully">
  <app-created [title]="reviewRequest.title" [deadline]="reviewRequest.deadline"></app-created>
</div>
